import { useEffect, useState } from 'react'

const DEFAULT_DEBOUNCE_DELAY = 500 // ms

export function useDebounced<T>(value: T, delay = DEFAULT_DEBOUNCE_DELAY): T {
  const [debounced, setDebounced] = useState<T>(value)

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(id)
  }, [value, delay])

  return debounced
}
